// default simple seo that can be shadowed

import React from 'react';
import { SEO as InternalSeo } from './support/seo/seo';
export const SEO = (props) => {
   return <InternalSeo {...props} />;
};
